// eslint-disable-next-line no-undef
ready(() => {

    const block = document.querySelector(".node-type-in-stock-technic .field-images"),
        blockContent = block.querySelector(" .values"),
        blockSlider = block.querySelector(".values"),
        blockSliderWrapper = block.querySelector(".values-wrapper"),
        teaser = block.querySelectorAll(".value:not(.swiper-slide-duplicate)"),
        arrows = block.querySelector(".arrows"),
        arrowsPrev = arrows.querySelector(".arrows__prev"),
        arrowsNext = arrows.querySelector(".arrows__next"),
        blockFooter = block.querySelector(".block__footer"),
        dots = block.querySelector(".dots");

    let swiper = "";
    function paramsSlider() {
        var options = {
            init: false,
            wrapperClass: "values-wrapper",
            slideClass: "value",
            slidesPerView: 1,
            slidesPerGroup: 1,
            setWrapperSize: true,
            grabCursor: true,
            spaceBetween: 0,
            watchOverflow: true,
            updateOnWindowResize: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            loop: false,
            loopFillGroupWithBlank: true,
            freeMode: false,
            freeModeMomentum: false,
            navigation: {
                nextEl: arrowsNext,
                prevEl: arrowsPrev,
                disabledClass: "arrows__arrow_disabled",
            },
            pagination: {
                el: dots,
                dynamicBullets: true,
                clickable: true,
            },
            autoplay: {
                delay: 3000
            },
        };
        swiper = new Swiper(blockSlider, options);
        swiper.init();
        // arrows ? arrows.style.opacity = "1" : null;
        // arrows ? arrows.style.visibility = "visible" : null;
        dots ? dots.style.display = "block" : null;
        function autoPlayStop() {
            swiper.autoplay.stop();
        }
        function autoPlayStart() {
            swiper.autoplay.start();
        }
        block.addEventListener("mouseenter", autoPlayStop);
        block.addEventListener("mouseleave", autoPlayStart);
    }
    // СЛАЙДЕР
    paramsSlider();

    // ОТКРЫТИЕ ГАЛЕРЕИ
    lightGallery(".node-type-in-stock-technic .field-images", "a");
    // END

    // ПЕРЕКЛЮЧЕНИЕ НАВИГАЦИОННЫХ ВКЛАДОК НА СТРАНИЦЕ
    const navtabsLinkArr = document.querySelectorAll(".navtabs__tab-link"),
        navtabsContentsArr = document.querySelectorAll(".navtabs__content");
    navtabsLinkArr[0].classList.add("is-active");
    navtabsContentsArr[0].classList.add("is-open");
    navtabsLinkArr.forEach(function(link){
        link.addEventListener("click", function(e){
            e.preventDefault();
            let url = e.currentTarget.getAttribute("href");
            navtabsLinkArr.forEach(function(a){
                a.classList.remove("is-active");
            });
            e.currentTarget.classList.add("is-active");
            navtabsContentsArr.forEach(function(a){
                a.classList.remove("is-open");
            });
            e.currentTarget.parentElement.parentElement.querySelector(url).classList.toggle("is-open");
        });
    });
    // END

});
